const scanCards = [
  {
    icon: "fa fa-search",
    title: "Collect Artifacts",
    description: "Conduct a comprehensive search and retrieval of designated company artifacts from online platforms and other credible sources.",
    timestamp: "Last updated 2 days ago",
    scanType: "collectArtifacts", // Unique identifier for PCI DSS compliance scan
  },
  {
    icon: "fa fa-code",
    title: "SOC 2 Compliance Scan",
    description: "Assess your organization's controls related to the Trust Services Criteria for SOC 2 compliance, ensuring data security, availability, processing integrity, confidentiality, and privacy.",
    timestamp: "Last updated 2 days ago",
    scanType: "soc2", // Unique identifier for SOC 2 compliance scan
  },
  {
    icon: "fa fa-globe",
    title: "GDPR Compliance Scan",
    description: "Verify your systems' compliance with the General Data Protection Regulation (GDPR) by evaluating data privacy practices, access control mechanisms, and user consent management.",
    timestamp: "Last updated 3 days ago",
    scanType: "gdpr", // Unique identifier for GDPR compliance scan
  },
  {
    icon: "fa fa-network-wired",
    title: "HIPAA Compliance Scan",
    description: "Ensure your systems are compliant with the Health Insurance Portability and Accountability Act (HIPAA), focusing on data protection and privacy for healthcare-related information.",
    timestamp: "Last updated 1 day ago",
    scanType: "hipaa", // Unique identifier for HIPAA compliance scan
  },
  {
    icon: "fa fa-cloud",
    title: "Cloud Compliance Scan",
    description: "Assess the security and compliance posture of your cloud infrastructure with industry standards, focusing on data protection, access control, and regulatory requirements.",
    timestamp: "Last updated 2 days ago",
    scanType: "cloudCompliance", // Unique identifier for cloud compliance scan
  },
  {
    icon: "fa fa-database",
    title: "ISO 27001 Compliance Scan",
    description: "Evaluate your systems' adherence to ISO 27001 standards for information security management, ensuring effective risk management practices and regulatory compliance.",
    timestamp: "Last updated 3 days ago",
    scanType: "iso27001", // Unique identifier for ISO 27001 compliance scan
  },
  {
    icon: "fa fa-plug",
    title: "SCA Compliance Scan",
    description: "Perform Software Composition Analysis (SCA) to ensure open-source components and third-party libraries used in your software meet compliance and security standards.",
    timestamp: "Last updated 6 days ago",
    scanType: "scaCompliance", // Unique identifier for SCA compliance scan
  },
  {
    icon: "fa fa-code",
    title: "SBOM Compliance Scan",
    description: "Generate and analyze the Software Bill of Materials (SBOM) to track the components and dependencies in your software, ensuring compliance with regulatory requirements for transparency.",
    timestamp: "Last updated 3 days ago",
    scanType: "sbomCompliance", // Unique identifier for SBOM compliance scan
  },
  {
    icon: "fa fa-cogs",
    title: "CMMC Compliance Scan",
    description: "Ensure your organization meets the Cybersecurity Maturity Model Certification (CMMC) standards, assessing your cybersecurity practices and controls for defense contractors.",
    timestamp: "Last updated 4 days ago",
    scanType: "cmmc", // Unique identifier for CMMC compliance scan
  },
  {
    icon: "fa fa-search",
    title: "FedRAMP Compliance Scan",
    description: "Assess the compliance of your cloud infrastructure with the Federal Risk and Authorization Management Program (FedRAMP) standards for federal cloud deployments.",
    timestamp: "Last updated 2 days ago",
    scanType: "fedramp", // Unique identifier for FedRAMP compliance scan
  },
  {
    icon: "fa fa-box",
    title: "Container Security Compliance",
    description: "Evaluate containerized applications for compliance with industry standards and regulatory requirements, including security misconfigurations and vulnerabilities in container images.",
    timestamp: "Last updated 3 days ago",
    scanType: "containerCompliance", // Unique identifier for container security compliance scan
  }
];

export default scanCards;
